import Modal from "bootstrap.native/dist/components/modal-native.esm";
import loadStylesheet from "../loadStylesheet";

let modalTriggers = document.getElementsByClassName("permit-modalTrigger");
if (modalTriggers) {
    for (let i = 0; i < modalTriggers.length; i++) {
        new Modal(modalTriggers[i]);
        modalTriggers[i].addEventListener("show.bs.modal", e => {
            loadStylesheet();
        });
    }
}
